import type { RealtimeHandler } from "@/shared/realtime";

import { billingStatusQueryOptions } from "../api/billingStatusQueryOptions";
import { PAYMENT_QUERY_KEY_PREFIX } from "../api/paymentQueryOptions";

// `billing.updated` → платёж или автоплатёж изменились: статус Pro и платежи перечитываются.
// Повтор события — ещё одна инвалидация, данные те же.
export const handleBillingUpdated: RealtimeHandler<"billing.updated"> = (
  _event,
  { queryClient },
) => {
  void queryClient.invalidateQueries({ queryKey: billingStatusQueryOptions().queryKey });
  void queryClient.invalidateQueries({ queryKey: PAYMENT_QUERY_KEY_PREFIX });
};
